import { yup } from '@medely/ui-kit';

export type MfaSmsCodeEntrySchemaProps = yup.InferType<typeof mfaSmsCodeEntrySchema>;

export type MfaSmsPasswordEntrySchemaProps = yup.InferType<typeof mfaPasswordEntrySchema>;

export type MfaSmsCodeEntrySchemaFieldNames = keyof MfaSmsCodeEntrySchemaProps;

export const mfaSmsCodeEntrySchema = yup.object({
  code: yup.string().required('Code is required.'),
});

export const mfaPasswordEntrySchema = yup.object({
  password: yup.string().required('Password is required.'),
});
